const getMatchingLeafPrefix = (fieldName, leafFieldNames) => {
  return [...leafFieldNames].sort((a, b) => b.length - a.length).find((leafFieldName) => fieldName.startsWith(`${leafFieldName}_`));
};

export default getMatchingLeafPrefix;
